import { all, call, put, takeEvery } from 'redux-saga/effects';
import { fetchJSON } from '../../helpers/api';
import {
  FETCH_USERS,
  INVITE_USER,
  DISABLE_USER,
  CHANGE_USER_ROLE,
} from './constants';
import {
  fetchUsersSuccess,
  fetchUsersFailed,
  inviteUserSuccess,
  inviteUserFailed,
  disableUserSuccess,
  disableUserFailed,
  changeUserRoleSuccess,
  changeUserRoleFailed,
} from './actions';
import { getLoggedInUserDecoded } from '../../helpers/authUtils';

const SERVER_URL = process.env.REACT_APP_KDM_API_ENDPOINT;
const user = getLoggedInUserDecoded();

let username = "No-User-Name";
let userEmail = "No-Email";
let userRole = "No-User-Role";
if (user) {
  username = user.name;
  userEmail = user.email;
  userRole = user.role;
}

function* fetchUsersSaga() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    //body: bodyContent,
  };

  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/User/getusers`, options);
    yield put(fetchUsersSuccess(response));
  } catch (error) {
    console.log(error)
    let message;
    if (error.status === 401) {
      message = "Unauthorized";
    } else {
      message = error.message || 'An error occurred';
    }
    yield put(fetchUsersFailed(error.message));
  }
}

function* inviteUserSaga({ payload: { email, name, roleNumber } }) {
  const bodyContent = JSON.stringify({ email: email, name: name, role: String(roleNumber) });

  const options = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: bodyContent,
  };

  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/User/newusersubscribe`, options);
    yield put(inviteUserSuccess(response));
    //put(inviteUserFailed("saga error")) // TODO: remove
  } catch (error) {
    let message;
    if (error.status === 409) {
      message = "User with this email already exists";
    } else if (error.status === 401) {
      message = "Unauthorized";
    } else {
      message = error.message || 'An error occurred';
    }
    yield put(inviteUserFailed(message));
  }
}

function* disableUserSaga({ payload: { userEmail } }) {
  const bodyContent = JSON.stringify({ email: userEmail });
  const options = {
    method: 'POST',
    body:bodyContent,
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/User/deleteuser`, options);
    yield put(disableUserSuccess(response));
  } catch (error) {
    let message;
    if (error.status === 409) {
      message = "Disable User - User not found";
    } else if (error.status === 401) {
      message = "Unauthorized";
    } else {
      message = error.message || 'An error occurred';
    }
    yield put(disableUserFailed(message));
  }
}

function* changeUserRoleSaga({ payload: { userEmail, newRole } }) {
  const bodyContent = JSON.stringify({ email: userEmail, role: newRole });
  const options = {
    method: 'POST',
    body: bodyContent,
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/User/changeuserrole`, options);
    yield put(changeUserRoleSuccess(response));
  } catch (error) {
    let message;
    if (error.status === 409) {
      message = "User not found, wrong email";
    } else if (error.status === 405) {
      message = "Missing email or role";
    } else if (error.status === 401) {
      message = "Unauthorized";
    }else {
      message = error.message || 'An error occurred';
    }
    yield put(changeUserRoleFailed(error.message));
  }
}

export function* watchFetchUsers() {
  yield takeEvery(FETCH_USERS, fetchUsersSaga);
}

export function* watchInviteUser() {
  yield takeEvery(INVITE_USER, inviteUserSaga);
}

export function* watchDisableUser() {
  yield takeEvery(DISABLE_USER, disableUserSaga);
}

export function* watchChangeUserRole() {
  yield takeEvery(CHANGE_USER_ROLE, changeUserRoleSaga);
}

export function* userManagementSaga() {
  yield all([
    call(watchFetchUsers),
    call(watchInviteUser),
    call(watchDisableUser),
    call(watchChangeUserRole),
  ]);
}

export default userManagementSaga;
